// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
require('./_set-collection-of')('WeakMap');



//////////////////
// WEBPACK FOOTER
// /opt/jenkins_home/workspace/marketing-campaigns_deploy_trigger_ce/6341/lib/node_modules/@core/macys-cli/node_modules/core-js/modules/es7.weak-map.of.js
// module id = 292
// module chunks = 0